import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import useMediaQuery from '../../hooks/useMediaQuery';

const DateTime = () => {
  const { language } = useLanguage();
  const [currentTime, setCurrentTime] = useState(new Date());
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat(language === 'en' ? 'en-US' : 'sw-TZ', {
      dateStyle: 'full',
      timeStyle: 'medium'
    }).format(date);
  };

  return (
    <div className={`${isDesktop ? 'text-sm' : 'text-xs'}`}>
      {formatDate(currentTime)}
    </div>
  );
};

export default DateTime;